import { NotificationInterface } from '@e3labs/isa-data-dictionary';
import { createSelector } from 'reselect';
import { RootState } from '~/store';

const selectNotification = (state: RootState) => state.notifications;

export const selectNotifications = createSelector(selectNotification, substate => ({
  loadingData: substate.loadingData as boolean,
  list: substate.list
}));

export const selectRecentsNotifications = createSelector(selectNotification, substate =>
  substate.list.allRows.slice(0, 10)
);

export const selectNotificationById = (id: string) =>
  createSelector(
    selectNotification,
    substate => substate.list.allRows.filter((notification: NotificationInterface<any>) => notification._id === id)[0]
  );
